import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FirestoreTimestamp } from "../../services";
import type { TimelineConfig } from "../../utils/timeline";
import type { MenuConfig } from "../../utils/menu";

export interface SiteState {
  siteId: string;
  name: string;
  slug: string;
  archived: boolean;
  expiresAt: FirestoreTimestamp | null;
    displayName: string | null;
  config: {
    language?: string;
    colorScheme?: {
      seeds?: Record<string, string>;
      palette: Record<string, string>;
    };
    permissions?: {
      allowGallery?: boolean;
      allowSingleImageDownload?: boolean;
      allowZipDownload?: boolean;
      allowTimeline?: boolean;
      allowMenu?: boolean;
      allowDjRequests?: boolean;
    };
    timeline?: TimelineConfig;
    menu?: MenuConfig;
    [key: string]: unknown;
  };
}

// We store the site in redux so epics can read it via withLatestFrom.
// UI code typically reads it through the useSite() hook.
export const siteSlice = createSlice({
  name: "site",
  initialState: null as SiteState | null,
  reducers: {
    setSite: (_state, action: PayloadAction<SiteState>) => action.payload,
    clearSite: () => null,
  },
});

export const { setSite, clearSite } = siteSlice.actions;
export default siteSlice.reducer;

